<template>
  <div v-if="isElem">
    〒
    <el-input v-model="zipCodePre" @input="inputAction" maxlength="3" type="tel" class="w-80px" :disabled="disabled"/>
    -
    <el-input v-model="zipCodePost" @input="inputAction" maxlength="4" type="tel" class="w-100px" :disabled="disabled"/>
  </div>
  <div v-else>
    〒
    <input v-model="zipCodePre" @input="inputAction" maxlength="3" type="tel" class="w-80px" :disabled="disabled"/>
    -
    <input v-model="zipCodePost" @input="inputAction" maxlength="4" type="tel" class="w-100px" :disabled="disabled"/>
  </div>
</template>

<script>
  export default {
    name: 'ZipCodeInput',
    props: ['value', 'disabled', 'isElem'],
    data () {
      return {
        zipCodePre: '',
        zipCodePost: ''
      }
    },
    methods: {
      initValue: function () {
        if (!this.value) {
          this.zipCodePre = ''
          this.zipCodePost = ''
          return
        }
        const zipCode = this.value.split('-')
        this.zipCodePre = zipCode[0] ? zipCode[0] : ''
        this.zipCodePost = zipCode[1] ? zipCode[1] : ''
      },
      inputAction: function (value) {
        if (this.zipCodePre || this.zipCodePost) {
          this.$emit('input', this.zipCodePre + '-' + this.zipCodePost)
        } else {
          this.$emit('input', '')
        }
      }
    },
    watch: {
      value () {
        this.initValue()
      }
    },
    created () {
      this.initValue()
    }
  }
</script>

<style scoped>
  .w-80px {
    width: 80px!important;
  }
  .w-100px {
    width: 100px!important;
  }
</style>
